// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form__section[data-v-282cc820] {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 700px;\n    padding: 16px 16px 32px 16px;\n}\n", ""]);
// Exports
module.exports = exports;
